// State registry and per-state land unit variants.
// Only differences from the default UP/North India factors are listed.
// Values in square metres per 1 unit.

export const STATES = [
  { code: "UP",  name: "Uttar Pradesh",   hi: "उत्तर प्रदेश" },
  { code: "BR",  name: "Bihar",           hi: "बिहार" },
  { code: "RJ",  name: "Rajasthan",       hi: "राजस्थान" },
  { code: "MP",  name: "Madhya Pradesh",  hi: "मध्य प्रदेश" },
  { code: "HR",  name: "Haryana",         hi: "हरियाणा" },
  { code: "PB",  name: "Punjab",          hi: "पंजाब" },
  { code: "DL",  name: "Delhi",           hi: "दिल्ली" },
  { code: "UK",  name: "Uttarakhand",     hi: "उत्तराखंड" },
  { code: "HP",  name: "Himachal Pradesh",hi: "हिमाचल प्रदेश" },
  { code: "JK",  name: "Jammu & Kashmir", hi: "जम्मू और कश्मीर" },
  { code: "WB",  name: "West Bengal",     hi: "पश्चिम बंगाल" },
  { code: "OD",  name: "Odisha",          hi: "ओडिशा" },
  { code: "JH",  name: "Jharkhand",       hi: "झारखंड" },
  { code: "AS",  name: "Assam",           hi: "असम" },
  { code: "GJ",  name: "Gujarat",         hi: "गुजरात" },
  { code: "MH",  name: "Maharashtra",     hi: "महाराष्ट्र" },
  { code: "GA",  name: "Goa",             hi: "गोवा" },
  { code: "KA",  name: "Karnataka",       hi: "कर्नाटक" },
  { code: "KL",  name: "Kerala",          hi: "केरल" },
  { code: "TN",  name: "Tamil Nadu",      hi: "तमिल नाडु" },
  { code: "AP",  name: "Andhra Pradesh",  hi: "आंध्र प्रदेश" },
  { code: "TG",  name: "Telangana",       hi: "तेलंगाना" },
  { code: "CG",  name: "Chhattisgarh",    hi: "छत्तीसगढ़" },
  { code: "SK",  name: "Sikkim",          hi: "सिक्किम" },
  { code: "MN",  name: "Manipur",         hi: "मणिपुर" },
  { code: "NL",  name: "Nagaland",        hi: "नागालैंड" },
  { code: "MZ",  name: "Mizoram",         hi: "मिज़ोरम" },
  { code: "TR",  name: "Tripura",         hi: "त्रिपुरा" },
  { code: "AR",  name: "Arunachal Pradesh", hi: "अरुणाचल प्रदेश" },
  { code: "ML",  name: "Meghalaya",       hi: "मेघालय" },
  { code: "CH",  name: "Chandigarh",      hi: "चंडीगढ़" },
  { code: "PY",  name: "Puducherry",      hi: "पुडुचेरी" },
  { code: "AN",  name: "Andaman & Nicobar", hi: "अंडमान और निकोबार" },
  { code: "LD",  name: "Lakshadweep",     hi: "लक्षद्वीप" },
  { code: "DN",  name: "Dadra & Nagar Haveli / DD", hi: "दादरा और नगर हवेली" },
  { code: "LA",  name: "Ladakh",          hi: "लद्दाख" },
];

// sqm-per-unit overrides. Any unit not listed falls back to base value in units.js.
// Bigha varies dramatically: UP/Uttarakhand ~2529.28, Bihar ~2726, Rajasthan (Pucca)~2508.38 / (Kaccha)~1618.7,
// MP ~2508.38, Haryana/Punjab ~4046.86, Assam/WB ~1337.8, HP ~2529.28.
export const STATE_UNIT_FACTORS = {
  UP: { bigha: 2529.2848, biswa: 126.4642, katha: 126.4642 },
  UK: { bigha: 2529.2848, biswa: 126.4642, katha: 126.4642 },
  HP: { bigha: 2529.2848 },
  MP: { bigha: 2508.38, biswa: 125.42 },
  RJ: { bigha: 2508.38, biswa: 125.42 },
  BR: { bigha: 2726.03, katha: 126.44 },
  JH: { bigha: 2726.03, katha: 126.44 },
  HR: { bigha: 4046.8564 },
  PB: { bigha: 4046.8564, kanal: 505.857, marla: 25.29285 },
  DL: { bigha: 1044.5 },
  WB: { bigha: 1337.8, katha: 66.89, chatak: 4.18 },
  AS: { bigha: 1337.8, katha: 267.56 },
  OD: { dismil: 40.468564 },
  GJ: { vigha: 1618.7 },
  MH: { guntha: 101.17141 },
  KA: { guntha: 101.17141, gunta: 101.17141 },
  TN: { ground: 222.967, cent: 40.468564 },
  KL: { cent: 40.468564, ground: 222.967 },
  AP: { ankanam: 6.6889, cent: 40.468564, gunta: 101.17141 },
  TG: { ankanam: 6.6889, cent: 40.468564, gunta: 101.17141 },
  GA: { cent: 40.468564 },
  SK: { ropani: 508.72 },
};

export function getStateFactor(stateCode, unitKey, fallback) {
  return STATE_UNIT_FACTORS[stateCode]?.[unitKey] ?? fallback;
}

export function stateName(code) {
  return STATES.find((s) => s.code === code)?.name || code;
}
